import React from "react";

import { DistrictsTableStateProviderProps, RowData, Sector } from "./types";
import DistrictsTable from "./DistrictsTable";

const DistrictsTableStateProvider: React.FC<DistrictsTableStateProviderProps> = ({
  tableData,
  onUpdate,
  readOnly = false,
}) => {
  const update = (
    setIsChipSelected: (sector?: Sector) => boolean,
    rowData?: RowData,
  ) => {
    if (!rowData) {
      return;
    }

    const newRowData: RowData = {
      ...rowData,
      sectors: rowData.sectors.map(
        (sector: Sector) =>
          ({
            ...sector,
            isSelected: setIsChipSelected(sector),
          } as Sector),
      ),
    };

    const newData = tableData?.map(item =>
      item.id === rowData.id ? newRowData : item,
    );

    onUpdate(newData);
  };

  const updateAll = (checked: boolean) => {
    const newData = tableData?.map(item => ({
      ...item,
      tableData: {
        checked,
      },
      sectors: item.sectors.map(
        (sector: Sector) =>
          ({
            ...sector,
            isSelected: checked,
          } as Sector),
      ),
    }));
    onUpdate(newData);
  };

  const onSelectionChange = (selectedRows: Array<RowData>) =>
    onUpdate(
      tableData.map(item => ({
        ...item,
        sectors: item.sectors.map(sector => ({
          ...sector,
          isSelected: selectedRows.map(r => r.id).includes(item.id),
        })),
      })),
    );

  return (
    <DistrictsTable
      data={tableData}
      onSelectAllCheck={updateAll}
      onSelectionChange={onSelectionChange}
      onChipCheck={(id, rowData) =>
        update(
          (sector?: Sector) =>
            sector?.id === id
              ? !sector?.isSelected
              : Boolean(sector?.isSelected),
          rowData,
        )
      }
      readOnly={readOnly}
    />
  );
};

export default DistrictsTableStateProvider;
